/**
 * OwalSortPredicate.js
 *
 * @description A class to describe a sortinfg operation.
 */

export class OwalSortPredicate {
  constructor ({ displayName, comparisonFunction, display = true, activeDefault } = {}) {
    this.displayName = displayName
    this.comparisonFunction = comparisonFunction
    this.hidden = !display
    this.activeDefault = activeDefault || false
  }
}
